import { fetchEntryConditions } from "../api/client";
import { usePoll } from "./usePoll";

export function useEntryConditions(symbol: string, intervalMs: number = 1000) {
  return usePoll(
    (signal) => fetchEntryConditions(symbol, signal),
    intervalMs,
    [symbol]
  );
}
